:host {
    display: block;
    container-type: inline-size;
    padding-bottom: 20px;
    --ux-iws-webinar-header-color: #000;
    --ux-iws-webinar-description-order: 1;
    --ux-iws-webinar-speakers-order: 2;
    --ux-iws-webinar-form-order: 3;
    --ux-iws-webinar-description-width: 90%;
    --ux-iws-webinar-speakers-width: 90%;
    --ux-iws-webinar-form-width: 100%;
    --ux-iws-webinar-header-content-width: 90%;
    --ux-iws-webinar-margin: 0 5%;
}

:host * {
    box-sizing: border-box;
}

:host([dark]) {
    --ux-iws-webinar-header-color: #fff;
}

.flex-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.form__shadow {
    background-color: #fff;
    box-shadow: 0 5px 25px rgba(19, 19, 19, 0.1);
    margin: 20px;
    padding: 20px 40px;
}

.header {
    width: 100%;

    &__image {
        min-height: 440px;
        background-size: cover;
        background-image: var(--ux-iws-webinar-header-image);
        color: var(--ux-iws-webinar-header-color);
        padding: 20px 0;
    }

    &__info {
        background-color: #c3cfd6;
    }

    &__info__content {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        flex-wrap: wrap;
        gap: 20px;
        padding: 20px 0;
    }
}

.header__text,
.header__title,
.header__info__content {
    width: var(--ux-iws-webinar-header-content-width);
    margin: var(--ux-iws-webinar-margin);
}

.description {
    order: var(--ux-iws-webinar-description-order);
    width: var(--ux-iws-webinar-description-width);
    margin: var(--ux-iws-webinar-margin);
}

.form {
    order: var(--ux-iws-webinar-form-order);
    width: var(--ux-iws-webinar-form-width);
    min-height: 20px; // Prevents the form from collapsing
}

.speakers {
    order: var(--ux-iws-webinar-speakers-order);
    width: var(--ux-iws-webinar-speakers-width);
    margin: var(--ux-iws-webinar-margin);
}

.speakers__desktop {
    display: none;
    flex-direction: row;
    flex-wrap: wrap;

    ::slotted(ux-iws-webinar-speaker) {
        width: 50%;
    }
}

@container (min-width: 768px) {
    :host * {
        --ux-iws-webinar-description-order: 1;
        --ux-iws-webinar-speakers-order: 3;
        --ux-iws-webinar-form-order: 2;
        --ux-iws-webinar-description-width: 41%;
        --ux-iws-webinar-speakers-width: 80%;
        --ux-iws-webinar-form-width: 44%;
        --ux-iws-webinar-header-content-width: 40%;
    }

    .speakers__desktop {
        display: flex;
    }

    .speakers__mobile {
        display: none;
    }

    .header__title {
        padding-top: 60px;
    }

    .form__shadow {
        margin-top: calc(-1 * var(--ux-iws-webinar-header-height) + 60px);
        min-height: 425px;
        margin-right: 0;
    }
}

@container (min-width: 1440px) {
    :host * {
        --ux-iws-webinar-description-order: 1;
        --ux-iws-webinar-speakers-order: 2;
        --ux-iws-webinar-form-order: 3;
        --ux-iws-webinar-description-width: 51%;
        --ux-iws-webinar-speakers-width: 51%;
        --ux-iws-webinar-form-width: 34%;
    }

    .flex-container {
        flex-flow: column wrap;
        height: var(--ux-iws-webinar-description-and-speakers-height);
    }

    .form {
        margin-right: 5%;
    }
}

.headline {
    margin-top: 20px;
    font-family: Frutiger-Light, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizelegibility;
    font-weight: 400;
}

.headline--large {
    font-size: 34px;

    @media only screen and (width >= 1920px) {
        font-size: 44px;
    }
    @media only screen and (width <= 1439px) {
        font-size: 28px;
    }
    @media only screen and (width <= 767px) {
        font-size: 23px;
    }
}

.headline--small {
    font-size: 20px;
    line-height: 1.25;

    @media only screen and (width >= 1920px) {
        font-size: 23px;
    }
}
